import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {DayOfWeekStaticLandingPageVo} from '../../common/shared/api/karina/vo/page/DayOfWeekStaticLandingPageVo.interface';
import {
  Group,
  GroupType,
  LayoutType,
  Maybe,
  SectionType,
  StaticLandingDayOfWeekParamInput,
  StaticLandingDayOfWeekSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createItem} from './Item';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';
import {createStaticLandingDayOfWeekSectionParam} from './StaticLandingDayOfWeekSectionParam';

export function createStaticLandingDayOfWeekSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    dayOfWeekStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    dayOfWeekStaticLandingPageVo: DayOfWeekStaticLandingPageVo;
    input: StaticLandingDayOfWeekParamInput;
    type?: LayoutType;
  }
): StaticLandingDayOfWeekSection {
  const param = createStaticLandingDayOfWeekSectionParam(vo, input);
  const result = {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.DayOfWeek}-section-${type}-${
        param.categoryUid
      }-${param.subcategory?.param}-${param.businessModel?.param}-${
        param.dayTab?.param
      }${input.screenUid ? `-${input.screenUid}` : ''}`,
    type: SectionType.LandingDayOfWeek,
    groups: [
      {
        id: `static-landing-${StaticLandingType.DayOfWeek}-group-${
          param.categoryUid
        }-${param.subcategory?.param}-${param.businessModel?.param}-${
          param.dayTab?.param
        }${input.screenUid ? `-${input.screenUid}` : ''}`,
        type: GroupType.CardView,
        items:
          vo.list?.map((item, index) =>
            createItem(userInfo, {
              viewItemVo: {
                viewItem: item,
                viewType: ViewTypeVo.SeriesCardView,
                sectionType: SectionType.LandingDayOfWeek,
              },
              index: (input.page ?? 0) * 25 + index,
            })
          ) || [],
      },
    ] as Group[],
    businessModelList:
      vo.bm_opt_list?.map(opt => createSortOption({filterOptionVo: opt})) || [],
    dayTabList:
      vo.tab_opt_list?.map(opt => createSortOption({filterOptionVo: opt})) ||
      [],
    subcategoryList:
      vo.subcat_opt_list?.map(opt => createSortOption({filterOptionVo: opt})) ||
      [],
    isEnd: vo.is_end || false,
    totalCount: vo.total_count || 0,
    promotionBanner: vo.section_promotion_banner
      ? createPromotionBannerItem({...vo.section_promotion_banner})
      : undefined,
    param,
  };

  return result;
}
